import { api } from "@/lib/api";

const KEY = "erp_err_sent";
const sig = (e) => `${String(e?.message || e).slice(0, 160)}|${String(e?.stack || "").split("\n").slice(1, 3).join("|")}`;

// Hata raporu gönderir; otomatik bildirimler oturum başına imza bazında tekilleştirilir
export async function reportError(error, { note = "", auto = true, componentStack = "" } = {}) {
  const s = sig(error);
  let sent = {};
  try { sent = JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { sent = {}; }
  if (auto && sent[s] && Date.now() - sent[s] < 3600e3) return { deduped: true };
  const body = {
    message: String(error?.message || error || "Bilinmeyen hata").slice(0, 1000),
    stack: `${error?.stack || ""}${componentStack ? `\n--- Bileşen ---${componentStack}` : ""}`.slice(0, 8000),
    route: window.location.pathname.slice(0, 300), platform: "web", device: navigator.userAgent.slice(0, 300), note: note.slice(0, 1000), auto,
  };
  const { data } = await api.post("/error-reports", body, { timeout: 10000 });
  sent[s] = Date.now();
  try { sessionStorage.setItem(KEY, JSON.stringify(sent)); } catch { /* depolama dolu */ }
  return data;
}
